export type GrToastTone = 'success' | 'error' | 'warning' | 'info';

export interface GrToastOptions {
  readonly heading?: string;
  readonly message: string;
  readonly tone?: GrToastTone;
  readonly durationMs?: number;
  readonly dismissible?: boolean;
}

// PrimeNG routes a message to the <p-toast> whose `key` matches it. Keying both sides means a
// second toast outlet added later can never steal the app-level notifications.
export const GR_TOAST_KEY = 'gr';

// Lands on the p-toast host so the global partial has a selector to hang our styling off.
export const GR_TOAST_STYLE_CLASS = 'gr-toast-panel';

// Our tone vocabulary and PrimeNG's severities agree everywhere except 'warning' / 'warn'.
export const GR_TOAST_TONE_SEVERITIES: Record<GrToastTone, string> = {
  success: 'success',
  error: 'error',
  warning: 'warn',
  info: 'info',
};

// Errors linger longest — they usually carry a next step the user has to read.
export const GR_TOAST_TONE_DURATIONS: Record<GrToastTone, number> = {
  success: 4000,
  info: 4000,
  warning: 6000,
  error: 8000,
};
